var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.randomScribble,{tag:"component",staticClass:"scribble",class:{'red-stroke':  _vm.redStroke},style:({
    strokeDasharray: _vm.length,
    strokeDashoffset: _vm.length,
    animationDuration: (_vm.duration + "s"),
    animationDelay: (_vm.delay + "s"),
    transform: ("translate(-50%, -50%) rotate(" + (_vm.rotate * 360) + "deg) scaleX(" + (_vm.scaleX > 0.5 ? 1 : -1) + ") scaleY(" + (_vm.scaleY > 0.5 ? 1 : -1) + ")"),
    top: ((_vm.top * 100) + "%"),
    left: ((_vm.left * 100) + "%")
  })})}
var staticRenderFns = []

export { render, staticRenderFns }